import http from './http'
import { getToken } from './auth'

const base = 'Badges'

export async function getBadgeById(id) {
    const { data } = await http.get(`${base}/${id}`, {
        headers: {
            'Authorization': 'Bearer ' + getToken()
        }
    })
    return data
}

export async function getBadgesByIdList(ids) {
    const { data } = await http.get(`${base}/list/${ids}`, {
        headers: {
            'Authorization': 'Bearer ' + getToken()
        }
    })
    return data
}

export async function getBadges() {

    const { data } = await http.get(`${base}/`, {
        headers: {
            'Authorization': 'Bearer ' + getToken()
        }
    })
    return data
}

export async function getAvailableBadges() {

    const { data } = await http.get(`${base}/available`, {
        headers: {
            'Authorization': 'Bearer ' + getToken()
        }
    })
    return data
}

export async function getLastUsedBadge() {

    const { data } = await http.get(`${base}/last-used`, {
        headers: {
            'Authorization': 'Bearer ' + getToken()
        }
    })
    return data
}

export async function createBadge(payload) {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getToken()
        }
    }

    const { data } = await http.post(base + '/generate', payload, config)
    return data
}

export async function deleteBadge(id) {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getToken(),
        }
    }

    const { data } = await http.delete(base + '/' + id, config)
    return data
}

export async function updateBadge(payload) {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getToken(),
        }
    }

    const { data } = await http.patch(base + '/' + payload.id, payload, config)
    return data
}

/** All tags (every year, void included) matching a code or number. */
export async function searchBadges(search) {
    const { data } = await http.get(`${base}/`, {
        params: search ? { search } : undefined,
        headers: {
            'Authorization': 'Bearer ' + getToken()
        }
    })
    return data
}

/** { last: badge|null, next: { code, year, seq } } */
export async function getLastIssuedBadge() {
    const { data } = await http.get(`${base}/last-issued`, {
        headers: {
            'Authorization': 'Bearer ' + getToken()
        }
    })
    return data
}

export async function voidBadge({ id, reason }) {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getToken(),
        }
    }

    const { data } = await http.patch(`${base}/${id}/void`, { reason: reason || null }, config)
    return data
}
